eshopApp.controller('ProductImageSwitcherController', ['$scope', '$http', function($scope, $http) {
    
}]).directive('ngElevateZoom', function() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            
            element.attr('data-zoom-image',attrs.dataZoomImage);
            
            $(element).ezPlus({
                gallery:'switcher_items', 
                zoomType : 'inner',
                galleryActiveClass: 'active', 
                constrainType : 'width', 
                constrainSize : 262,
                
                cursor: 'crosshair', 
                imageCrossfade: true,
                scrollZoom : true,
            });

        }
    };
});
